import "./index.css";

function About() {
    return (
        <div className="about_block" id="about">
            <div className="about">ABOUT</div>
            <div className="about_headline">Software development</div>
            <p className="about_desc">
                Bizcon specializes in software development, system integration
                and platform maintenance. We are a professional and reliable
                company, providing various software products and various
                customized services.
                <br />
                <br />
                Bizcon takes the conception of ​​achieving a happiness
                enterprise as its philosophy. In addition to profit is the basis
                of enterprise survival, we believe we should also do our best to
                all partners to make customers, employees, society and the
                environment happier and better.
            </p>
        </div>
    );
}

export default About;
